import React from "react";
import "./palam_button.scss";

class PalamToggleSwitch extends React.PureComponent {
    render(){
        let { children, isActive, ...rest } = this.props

        let cssClass="palam-toggle-switch";
        cssClass += isActive?" active":"";
        return(
            <button className={cssClass} {...rest}>{children}</button>
        );
    }
}

export default PalamToggleSwitch